import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faCalendarWeek,
  faPlusCircle,
  faPlus,
  faCaretDown,
  faCoins,
  faExclamationCircle,
  faTicketAlt,
  faUser,
  faUsers,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faStickyNote,
  faHammer,
  faCheckCircle,
  faClock,
  faTrash,
  faSave,
  faSearch,
  faSort,
  faStar,
  faQuestionCircle,
  faPalette,
  faMagic,
  faMoneyBillWave,
  faLink,
  faCog,
  faTimesCircle,
  faBan,
  faRibbon,
  faFilter
} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faCalendarWeek,
  faPlusCircle,
  faPlus,
  faCaretDown,
  faCoins,
  faExclamationCircle,
  faTicketAlt,
  faUser,
  faUsers,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faStickyNote,
  faHammer,
  faCheckCircle,
  faClock,
  faTrash,
  faSave,
  faSearch,
  faSort,
  faStar,
  faQuestionCircle,
  faPalette,
  faMagic,
  faMoneyBillWave,
  faLink,
  faCog,
  faTimesCircle,
  faBan,
  faRibbon,
  faFilter
)

export default FontAwesomeIcon
